<template>
	<view class="index">
		<view class="index-j-head">
			<view :style="{ width: '100%', height: statusbarHeight + 'px' }"></view>
			<view class="index-c-title" :style="{ height: navHeight + 'px' }">
				<text>我的订单</text>
			</view>
		</view>
		<!-- 发单方 -->
		<view class="index-labs" v-if="type === 0" :style="{ top: statusbarHeight + navHeight + 'px' }">
			<view class="index-labs-row">
				全部
				<view class="index-labs-row-x"></view>
			</view>
			<view class="index-labs-row active">待接单</view>
			<view class="index-labs-row">已接单</view>
			<view class="index-labs-row">进行中</view>
			<view class="index-labs-row">待评价</view>
			<view class="index-labs-row">已取消</view>
		</view>
		<!-- 接单方 -->
		<view class="index-labs" v-if="type === 1" :style="{ top: statusbarHeight + navHeight + 'px' }">
			<view class="index-labs-row">
				全部
				<view class="index-labs-row-x"></view>
			</view>
			<view class="index-labs-row active">已接单</view>
			<view class="index-labs-row">进行中</view>
			<view class="index-labs-row">已完成</view>
			<view class="index-labs-row">已取消</view>
		</view>
		<!-- 发单方 -->
		<view class="index-list" v-if="type === 0">
			<view class="index-list-item">
				<view class="index-list-item-head">
					<view class="index-list-item-head-l">
						<view class="xoam"></view>
						<text>订餐单</text>
					</view>
					<view class="index-list-item-head-r">待接单方接单</view>
				</view>
				<view class="index-list-item-info">
					午餐5元(30份)｜晚餐8元(20份)
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_location@2x.png" mode="widthFix"></image>
					<text>长江西路大蜀山森林公园西门保安室</text>
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_time@2x.png" mode="widthFix"></image>
					<text>07-26 至 07-27（2天）</text>
				</view>
				<view class="index-list-item-price">
					<text>预估：</text>
					<text>¥1000.00</text>
				</view>
				<view class="eidt">
					<view></view>
					<view class="eidt-right">
						<view class="eidt-close">取消订单</view>
						<!-- <view class="eidt-close">删除订单</view>
						<view class="eidt-phone">联系师傅</view>
						<view class="eidt-phone">评价订单</view>
						<view class="eidt-btn">修改订单</view>
						<view class="eidt-btn">完成并支付</view> -->
					</view>
				</view>
			</view>
			<view class="index-list-item">
				<view class="index-list-item-head">
					<view class="index-list-item-head-l">
						<view class="xoam"></view>
						<text>运货单-小货车-厢式</text>
					</view>
					<view class="index-list-item-head-r">待接单方接单</view>
				</view>
				<view class="index-list-item-info">
					葡萄｜20000斤｜需2辆
				</view>
				<view class="index-list-item-date">
					<image src="/static/icon/order_ic_time@2x.png" mode="widthFix"></image>
					<text>07-26 至 07-27（2天）</text>
				</view>
				<view class="address">
					<view class="address-xian"></view>
					<view class="address-row">
						<image src="/static/icon/ic_qidian@2x.png" mode="widthFix"></image>
						<text>长江西路大蜀山森林公园西门保安室</text>
					</view>
					<view class="address-row">
						<image src="/static/icon/ic_jingguo@2x.png" mode="widthFix"></image>
						<text>长江西路大蜀山森林公园东门保安室</text>
					</view>
					<view class="address-row">
						<image src="/static/icon/ic_zhongdian@2x.png" mode="widthFix"></image>
						<text>安徽莲花科技产业园豆米科技有限公司</text>
					</view>
				</view>
				<view class="index-list-item-price">
					<text>预估：</text>
					<text>¥1000.00</text>
				</view>
				<view class="eidt">
					<view></view>
					<view class="eidt-right">
						<view class="eidt-close">取消订单</view>
						<!-- <view class="eidt-close">删除订单</view>
						<view class="eidt-phone">联系师傅</view>
						<view class="eidt-phone">评价订单</view>
						<view class="eidt-btn">修改订单</view>
						<view class="eidt-btn">完成并支付</view> -->
					</view>
				</view>
			</view>
			<view class="index-list-item">
				<view class="index-list-item-head">
					<view class="index-list-item-head-l">
						<view class="xoam"></view>
						<text>用工单-采摘工</text>
					</view>
					<view class="index-list-item-head-r">待接单</view>
				</view>
				<view class="index-list-item-info">
					葡萄｜2000斤
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_location@2x.png" mode="widthFix"></image>
					<text>长江西路大蜀山森林公园西门保安室</text>
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_time@2x.png" mode="widthFix"></image>
					<text>07-26 至 07-27（2天）</text>
				</view>
				<view class="index-list-item-price">
					<text>预估：</text>
					<text>¥1000.00</text>
				</view>
				<view class="eidt">
					<view></view>
					<view class="eidt-right">
						<view class="eidt-close">取消订单</view>
						<!-- <view class="eidt-close">删除订单</view>
						<view class="eidt-phone">联系师傅</view>
						<view class="eidt-phone">评价订单</view>
						<view class="eidt-btn">修改订单</view>
						<view class="eidt-btn">完成并支付</view> -->
					</view>
				</view>
			</view>
		</view>
		<!-- 接单方 -->
		<view class="index-list" v-if="type === 1">
			<view class="index-list-item">
				<view class="index-list-item-head">
					<view class="index-list-item-head-l">
						<view class="xoam"></view>
						<text>订餐单</text>
						<view class="tips">系统派单</view>
					</view>
					<view class="index-list-item-head-r">已接单</view>
				</view>
				<view class="index-list-item-info">
					午餐5元(30份)｜晚餐8元(20份)
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_location@2x.png" mode="widthFix"></image>
					<text>长江西路大蜀山森林公园西门保安室</text>
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_time@2x.png" mode="widthFix"></image>
					<text>07-26 至 07-27（2天）</text>
				</view>
				<view class="index-list-item-price">
					<text>预估：</text>
					<text>¥1000.00</text>
				</view>
				<view class="eidt">
					<view class="eidt-tips">
						<image src="/static/icon/ic_tip@2x.png" mode="widthFix"></image>
						<text>订单已修改</text>
					</view>
					<view class="eidt-right">
						<view class="eidt-close">取消订单</view>
						<!-- <view class="eidt-close">删除订单</view>
						<view class="eidt-phone">联系师傅</view>
						<view class="eidt-phone">评价订单</view>
						<view class="eidt-btn">修改订单</view>
						<view class="eidt-btn">完成并支付</view> -->
					</view>
				</view>
			</view>
			<view class="index-list-item">
				<view class="index-list-item-head">
					<view class="index-list-item-head-l">
						<view class="xoam"></view>
						<text>运货单-小货车-厢式</text>
						<view class="tips1">自主抢单</view>
					</view>
					<view class="index-list-item-head-r">已接单</view>
				</view>
				<view class="index-list-item-info">
					葡萄｜20000斤｜需2辆
				</view>
				<view class="index-list-item-date">
					<image src="/static/icon/order_ic_time@2x.png" mode="widthFix"></image>
					<text>07-26 至 07-27（2天）</text>
				</view>
				<view class="address">
					<view class="address-xian"></view>
					<view class="address-row">
						<image src="/static/icon/ic_qidian@2x.png" mode="widthFix"></image>
						<text>长江西路大蜀山森林公园西门保安室</text>
					</view>
					<view class="address-row">
						<image src="/static/icon/ic_jingguo@2x.png" mode="widthFix"></image>
						<text>长江西路大蜀山森林公园东门保安室</text>
					</view>
					<view class="address-row">
						<image src="/static/icon/ic_zhongdian@2x.png" mode="widthFix"></image>
						<text>安徽莲花科技产业园豆米科技有限公司</text>
					</view>
				</view>
				<view class="index-list-item-price">
					<text>预估：</text>
					<text>¥1000.00</text>
				</view>
				<view class="eidt">
					<view></view>
					<view class="eidt-right">
						<view class="eidt-close">取消订单</view>
						<!-- <view class="eidt-close">删除订单</view>
						<view class="eidt-phone">联系师傅</view>
						<view class="eidt-phone">评价订单</view>
						<view class="eidt-btn">修改订单</view>
						<view class="eidt-btn">完成并支付</view> -->
					</view>
				</view>
			</view>
			<view class="index-list-item">
				<view class="index-list-item-head">
					<view class="index-list-item-head-l">
						<view class="xoam"></view>
						<text>用工单-采摘工</text>
						<view class="tips1">自主抢单</view>
					</view>
					<view class="index-list-item-head-r">待接单</view>
				</view>
				<view class="index-list-item-info">
					葡萄｜2000斤
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_location@2x.png" mode="widthFix"></image>
					<text>长江西路大蜀山森林公园西门保安室</text>
				</view>
				<view class="index-list-item-dz">
					<image src="/static/icon/order_ic_time@2x.png" mode="widthFix"></image>
					<text>07-26 至 07-27（2天）</text>
				</view>
				<view class="index-list-item-price">
					<text>预估：</text>
					<text>¥1000.00</text>
				</view>
				<view class="eidt">
					<view></view>
					<view class="eidt-right">
						<view class="eidt-close">取消订单</view>
						<!-- <view class="eidt-close">删除订单</view>
						<view class="eidt-phone">联系师傅</view>
						<view class="eidt-phone">评价订单</view>
						<view class="eidt-btn">修改订单</view>
						<view class="eidt-btn">完成并支付</view> -->
					</view>
				</view>
			</view>
		</view>
		<!-- <view class="index-wu">
			<image src="/static/icon/default_login@2x.png" mode="widthFix"></image>
			<text>您还没有登录，请登录后查看订单</text>
			<button>登录</button>
		</view> -->
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight'])
		},
		data() {
			return {
				type: 1
			};
		}
	}
</script>

<style>
	page {
		background-color: #F7F7F7;
	}
</style>

<style lang="scss" scoped>
	.index {
		width: 100%;
		.index-j-head {
			width: 100%;
			background-color: #ffffff;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 9;
			.index-c-title {
				width: 100%;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				text {
					font-weight: bold;
					font-size: 36rpx;
					color: #111111;
				}
			}
		}
		.index-list {
			width: 100%;
			padding: 20rpx 30rpx;
			box-sizing: border-box;
			.index-list-item {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 20rpx;
				margin-bottom: 20rpx;
				&:last-child {
					margin: 0 !important;
				}
				.eidt {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.eidt-tips {
						flex-shrink: 0;
						display: flex;
						align-items: center;
						image {
							width: 26rpx;
							height: 26rpx;
							margin-right: 12rpx;
						}
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #FF0000;
						}
					}
					.eidt-close {
						width: 160rpx;
						height: 64rpx;
						font-weight: 400;
						font-size: 28rpx;
						color: #666666;
						line-height: 64rpx;
						text-align: center;
						border-radius: 34rpx;
						border: 1rpx solid #B2B2B2;
					}
					.eidt-phone {
						width: 160rpx;
						height: 64rpx;
						line-height: 64rpx;
						text-align: center;
						font-weight: 400;
						font-size: 28rpx;
						color: #00BC12;
						border-radius: 34rpx;
						border: 1rpx solid #00BC12;
					}
					.eidt-btn {
						width: 160rpx;
						height: 64rpx;
						line-height: 64rpx;
						text-align: center;
						font-weight: 400;
						font-size: 28rpx;
						color: #FFFFFF;
						background: #00BC12;
						border-radius: 34rpx;
					}
				}
				.index-list-item-price {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: flex-end;
					margin-bottom: 20rpx;
					text {
						&:nth-child(1) {
							font-weight: 400;
							font-size: 26rpx;
							color: #333333;
						}
						&:nth-child(2) {
							font-weight: 600;
							font-size: 36rpx;
							color: #FF0000;
						}
					}
				}
				.index-list-item-dz {
					width: 100%;
					display: flex;
					align-items: center;
					margin-bottom: 20rpx;
					image {
						width: 32rpx;
						height: 32rpx;
						flex-shrink: 0;
						margin-right: 16rpx;
					}
					text {
						flex: 1;
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
					}
				}
				.index-list-item-info {
					font-weight: 400;
					font-size: 28rpx;
					color: #888888;
					margin-bottom: 20rpx;
				}
				.address {
					width: 100%;
					background: #F7F7F7;
					border-radius: 16rpx;
					padding: 30rpx;
					box-sizing: border-box;
					margin-bottom: 24rpx;
					position: relative;
					.address-xian {
						position: absolute;
						top: 17px;
						left: 24px;
						width: 1rpx;
						height: calc(100% - 60rpx);
						border-right: 2rpx dashed #B2B2B2;
					}
					.address-row {
						position: relative;
						z-index: 2;
						width: 100%;
						display: flex;
						align-items: center;
						margin-bottom: 30rpx;
						&:last-child {
							margin: 0 !important;
						}
						image {
							width: 36rpx;
							height: 36rpx;
							flex-shrink: 0;
							margin-right: 24rpx;
						}
						text {
							font-weight: 400;
							font-size: 28rpx;
							color: #333333;
						}
					}
				}
				.index-list-item-date {
					width: 100%;
					display: flex;
					align-items: center;
					margin-bottom: 20rpx;
					image {
						flex-shrink: 0;
						width: 28rpx;
						height: 28rpx;
						margin-right: 18rpx;
					}
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
					}
				}
				.index-list-item-head {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 20rpx;
					.index-list-item-head-l {
						display: flex;
						align-items: center;
						.xoam {
							width: 6rpx;
							height: 30rpx;
							background: #00BC12;
							border-radius: 4rpx;
							margin-right: 20rpx;
						}
						text {
							font-weight: 600;
							font-size: 32rpx;
							color: #222222;
							margin-right: 12rpx;
						}
						.tips {
							padding: 4rpx 12rpx;
							border-radius: 8rpx;
							font-weight: 400;
							font-size: 24rpx;
							color: #00BC12;
							border: 2rpx solid #00BC12;
						}
						.tips1 {
							padding: 4rpx 12rpx;
							border-radius: 8rpx;
							font-weight: 400;
							font-size: 24rpx;
							color: #FD9E24;
							border: 2rpx solid #FD9E24;
						}
					}
					.index-list-item-head-r {
						font-weight: 400;
						font-size: 28rpx;
						color: #FF0000;
					}
				}
			}
		}
		.index-labs {
			width: 100%;
			height: 90rpx;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #FFFFFF;
			position: sticky;
			left: 0;
			.active {
				font-weight: 500 !important;
				font-size: 32rpx !important;
				color: #222222 !important;
			}
			.index-labs-row {
				flex: 1;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: 30rpx;
				color: #666666;
				position: relative;
				.index-labs-row-x {
					position: absolute;
					bottom: 0;
					left: 50%;
					width: 40rpx;
					height: 2rpx;
					background-color: #00BC12;
					transform: translate(-50%, 0);
				}
			}
		}
		.index-wu {
			width: 100%;
			margin-top: 286rpx;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			image {
				width: 300rpx;
				height: 300rpx;
			}
			text {
				font-weight: 400;
				font-size: 28rpx;
				color: #999999;
				margin-bottom: 40rpx;
			}
			button {
				width: 160rpx;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: #00BC12;
				border-radius: 36rpx;
				font-weight: 500;
				font-size: 32rpx;
				color: #FFFFFF;
			}
		}
	}
</style>
